import { makeAutoObservable } from 'mobx'
import searchResult1 from '../data/SearchResultData'
import { cloneDeep } from 'lodash'

class SearchStore {
  searchTitlesOnly = false
  searchText = ''
  searchDrawerVisible = false
  results = searchResult1.results
  filteredCurrentResult = []

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  get differentResults() {
    return this.results
  }

  currentResults = () => {
    const results = cloneDeep(this.results)
    this.filteredCurrentResult = results.filter(result => {
      const children = result.children.filter(child =>
        this.searchTitlesOnly
          ? child.title.includes(this.searchText)
          : child.title.includes(this.searchText) ||
            child.path.includes(this.searchText) ||
            child.snippet.includes(this.searchText),
      )

      result.children = children || []
      return children.length > 0
    })
  }
  invalidateSearch = () => {
    this.setSearchText('')
  }
  setSearchText = value => {
    if (value.length === 0) {
      this.filteredCurrentResult = [...this.results]
    }
    this.searchText = value
  }

  setSearchDrawerVisible = value => {
    this.searchDrawerVisible = value
  }

  setSearchTitlesOnly = value => {
    this.searchTitlesOnly = value
  }
}

export default SearchStore
